module.exports = __webpack_public_path__ + "distribution/img/kanjia-success.510ed634.png";